export const TKeyNavigation = {
  SIDEBAR_OFFER_ADD: "SIDEBAR_OFFER_ADD",
  HOME: "HOME",
  CALL_ANALYSIS: "CALL_ANALYSIS",
  HELP_SUPPORT: "HELP_SUPPORT",
  SIDEBAR_TOGGLE: "SIDEBAR_TOGGLE",
  TERMS: "TERMS",
  PRIVACY: "PRIVACY",
  AFFILIATION: "AFFILIATION",
  ADMINISTRATION: "ADMINISTRATION",
  SIDEBAR_TOOLS_TITLE: "SIDEBAR_TOOLS_TITLE",
  SIDEBAR_OUR_TOOLS_TITLE: "SIDEBAR_OUR_TOOLS_TITLE",
  HELP_CATEGORY_RESOURCES: "HELP_CATEGORY_RESOURCES",
  HELP_CATEGORY_INTEGRATIONS: "HELP_CATEGORY_INTEGRATIONS",
  HELP_CATEGORY_LEGAL: "HELP_CATEGORY_LEGAL",
} as const;
